module.exports = {"sm":"640px","md":"768px","lg":"1024px","xl":"1280px"}


//////////////////
// WEBPACK FOOTER
// ./~/v-calendar/src/utils/defaults/screens.json
// module id = 670
// module chunks = 94